export default "__VITE_ASSET__C7IL87KJ__"